import React from "react";
import { SocialIcon } from "react-social-icons";

import "./Social.css";

const icons = {
  width: "25px",
  height: "25px",
  margin: "0 5px",
};

const Social = () => (
  <div>
    <SocialIcon
      style={icons}
      className="icon"
      url="https://www.facebook.com/liknoss/"
    />
    <SocialIcon
      style={icons}
      className="icon"
      url="https://twitter.com/liknoss?lang=encolor="
    />
    <SocialIcon
      style={icons}
      className="icon"
      url="https://www.linkedin.com/company/liknoss/"
    />
    <SocialIcon
      style={icons}
      className="icon"
      url="https://www.pinterest.com/pin/74942781285893614/"
    />
  </div>
);

export default Social;



// WEBPACK FOOTER //
// ./src/components/Social-Icons/Social.js